<template>
  <div class="purchase">

    <div class="myheaderbar">
      <h1>GoogleContacts</h1>
    </div>
    
    <br>
    <div  style="margin: 1em;">
      <b-field>
        <h1><b>Google Contact Sync</b></h1>
      </b-field>

      <div style="height: 2em"></div>
      
      TODO HERE
      <!-- <ListPanel/> -->
    </div>
    <b-button @click="$router.back(-1)"
      icon-left="fas fa-search"
      type="is-primary">
      BACK
    </b-button>

  </div>
</template>

<script>
  // import ListPanel from '@/components/main/topten/ListPanel.vue';

  export default {
    name: 'GoogleContactView',
    components: {
      // ListPanel
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
</style>